import React from 'react';
import PropTypes from 'prop-types';
import { Tag, Spacer, Icon } from '@ontruck/orc';

import { CopyableText } from 'modules/Common/Copy';

import { GroupageTag } from './styled';
import { TagGroup } from 'components/ServiceTag';
import { HighPrioTag } from '../../../../high-prio-order';
import { IS_TENANT } from 'tenant/config';

const t = {
  prio: 'Prio',
  new: 'FTB',
  insured: 'Insured',
  cancelled: 'Cancelled',
  export: 'exportación',
  import: 'importación',
};

const ShipperOrderCell = ({
  className,
  shipperCompanyName,
  shipperOrderId,
  isHighPriority,
  isNew,
  isInsured,
  isPriority,
  isGroupage,
  isRecurring,
  isCancelled,
  isRemovable,
  onRemoveClick,
  is_export,
  skin,
}) => {
  return (
    <Spacer className={className} mRight="XS">
      <GroupageTag groupage={isGroupage} skin={skin}>
        <CopyableText text={`S${shipperOrderId}`} />
        {isHighPriority && !IS_TENANT && (
          <Spacer mLeft="XXS">
            <TagGroup>
              <HighPrioTag />
            </TagGroup>
          </Spacer>
        )}
        {isRecurring ? (
          <Spacer mLeft="XXS" mRight="XXS">
            <Icon glyph="repeat" size="1.6rem" color="grey500" />
          </Spacer>
        ) : (
          <Spacer mLeft="XXS" mRight="XXS">
            -
          </Spacer>
        )}
        <div className="ShipperOrderCell-shipperName">{shipperCompanyName}</div>
      </GroupageTag>
      <TagGroup>
        {IS_TENANT && (
          <Tag
            skin={is_export ? 'modernGrey' : 'priority'}
            weight="bold"
            textTransform="uppercase"
            className="ShipperOrderCell-tag"
          >
            {is_export ? t.export : t.import}
          </Tag>
        )}
        {isNew && !IS_TENANT && (
          <Tag
            skin="modernGrey"
            weight="bold"
            textTransform="uppercase"
            className="ShipperOrderCell-tag"
          >
            {t.new}
          </Tag>
        )}
        {isInsured && (
          <Tag
            skin="modernLightGrey"
            weight="bold"
            textTransform="uppercase"
            className="ShipperOrderCell-tag"
          >
            {t.insured}
          </Tag>
        )}
        {isPriority && !IS_TENANT && (
          <Tag
            skin="priority"
            weight="bold"
            textTransform="uppercase"
            className="ShipperOrderCell-tag"
          >
            {t.prio}
          </Tag>
        )}
        {isCancelled && (
          <Tag
            skin="modernRed"
            weight="bold"
            textTransform="uppercase"
            className="ShipperOrderCell-tag"
          >
            {t.cancelled}
          </Tag>
        )}
        {isRemovable && (
          <button type="button" className="ShipperOrderCell-clear-button" onClick={onRemoveClick}>
            <Icon glyph="close" size="1.2rem" color="grey500" />
          </button>
        )}
      </TagGroup>
    </Spacer>
  );
};

ShipperOrderCell.propTypes = {
  shipperCompanyName: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  shipperOrderId: PropTypes.number.isRequired,
  isNew: PropTypes.bool.isRequired,
  isInsured: PropTypes.bool.isRequired,
  isPriority: PropTypes.bool.isRequired,
  isGroupage: PropTypes.bool.isRequired,
  isRecurring: PropTypes.bool.isRequired,
  isCancelled: PropTypes.bool.isRequired,
  isHighPriority: PropTypes.bool,
  skin: PropTypes.string.isRequired,
  isRemovable: PropTypes.bool,
  onRemoveClick: PropTypes.func,
};

ShipperOrderCell.defaultProps = {
  isRemovable: false,
};

export default ShipperOrderCell;
